import Backbone from 'backbone';

const MasterDataModel = Backbone.Model.extend({
  initialize: function (model, opts) {
    var options = opts || {};
    this.client = options.clientId;
    this.id = options.id;
  },

  url: function () {
    if (this.id) {
      return `clients/${this.client}/masterdata/${this.id}`;
    }
    return `clients/${this.client}/masterdata`;
  },
});

export default MasterDataModel;
